
import CSearchList from '@/components/c-search-list'
import CTable from '@/components/c-table'
import { getIndexConfig, getTableConfig, inputList } from './config'
import { defineComponent, toRefs, reactive, onMounted } from 'vue'
import detailDialog from './component/detail.vue'
import dayjs from 'dayjs'
import {
  getList,
  dropdownOfEnterprise,
  enterpriseViolationSettingQuery,
} from './api'
export default defineComponent({
  components: {
    CSearchList,
    CTable,
    detailDialog,
  },
  setup() {
    const remoteData1 = reactive({
      options: [],
      isLoading: false,
      remoteMethod: (val) => {
        enterpriseViolationSettingQuery({ orgName: val }).then((res) => {
          remoteData1.options = res.data.map((item) => {
            return {
              label: item.orgName,
              value: item.code,
            }
          })
        })
      },
    })
    const remoteData2 = reactive({
      options: [],
      isLoading: false,
      remoteMethod: (val) => {
        dropdownOfEnterprise({ value: val }).then((res) => {
          remoteData2.options = res.data.map((item) => {
            return {
              label: item.value,
              value: item.key,
            }
          })
        })
      },
    })
    const data = reactive({
      inputList: inputList(
        { ...toRefs(remoteData1) },
        { ...toRefs(remoteData2) }
      ),
      ...getIndexConfig(),
      currentRow: [],
      isFlag: false,
    })
    // 表单组件变量
    const tableConfig = reactive({
      ...getTableConfig(),
    })
    /**
     * @description:列表接口
     * @return {void}
     */
    const getListApi = () => {
      const obj = Object.assign(
        { ...data.queryForm },
        {
          currPage: tableConfig.pagination.currentPage,
          pageSize: tableConfig.pagination.pageSize,
          createTimeStart:
            data.queryForm.Time instanceof Array
              ? dayjs(data.queryForm.Time[0]).format('YYYY-MM-DD HH:mm:00')
              : '',
          createTimeEnd:
            data.queryForm.Time instanceof Array
              ? dayjs(data.queryForm.Time[1]).format('YYYY-MM-DD HH:mm:00')
              : '',
        }
      )
      delete obj.Time
      getList(obj).then((res) => {
        tableConfig.data = res.data.list
        tableConfig.pagination.total = res.data.total
      })
    }
    /**
     * @description: 重置事件
     * @param {*} val
     * @return {void}
     */
    const handleReset = (val: object) => {
      data.queryForm = val
      // getListApi()
      // console.log(val)
    }
    /**
     * @description: 查询事件
     * @param {*} params
     * @return {viod}
     */
    const handleSearch = (params: object) => {
      data.queryForm = Object.assign({}, params)
      getListApi()
    }
    /**
     * @description: 翻页
     * @param {*} val  当前页数
     * @return {void}
     */
    const pageCurrentChange = (val: number) => {
      tableConfig.pagination.currentPage = val
      getListApi()
    }
    /**
     * @description: 每页条数
     * @param {*} val 数量
     * @return {void}
     */
    const pageSizeChange = (val: number) => {
      tableConfig.pagination.currentPage = 1
      tableConfig.pagination.pageSize = val
      getListApi()
    }

    const onToggle = (row, name) => {
      data[name] = !data[name]
      row && (data.currentRow = row)
    }

    onMounted(() => {
      // 默认展示当天 0 点 ~ 次日 0 点
      handleSearch({
        Time: [
          new Date(new Date().setHours(0, 0, 0, 0)),
          new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000)
        ],
      })
    })
    return {
      handleReset,
      handleSearch,
      pageCurrentChange,
      pageSizeChange,
      tableConfig,
      ...toRefs(data),
      onToggle,
    }
  },
})
